<template>
  <div class="container mt-5" style="font-size: 28px">
    <div class="row">
      <div class="offset-md-0 col-md-4 offset-2 col-8 form-group">
        <div align="center" class="detail-content row ml-0 mr-0 ">
          <img class=" pl-lg-3 img-detail " src="../../assets/detail-image-1.png">
          <div class="text-right ml-4">
            <span>เสียชีวิต</span>
            <br>
            <template v-if="countPatient">
              <span>{{ countPatient ? countPatient[0].death_patient_total : '' }} ราย</span>
            </template>
            <template v-else>
              <span>0 ราย</span>
            </template>
          </div>
        </div>
      </div>
      <div class="offset-md-0 col-md-4 offset-2 col-8 form-group">
        <div class="detail-content row ml-0 mr-0 ">
          <img class="pl-xl-5 pl-lg-3 img-detail " src="../../assets/patient.png">
          <div class="text-right ml-4">
            <span>บาดเจ็บ</span>
            <br>
            <template v-if="countPatient[0].injury_patient_total">
              <span>{{ countPatient[0].injury_patient_total }} ราย</span>
            </template>
            <template v-else>
              <span>0 ราย</span>
            </template>
          </div>
        </div>
      </div>
      <div class="offset-md-0 col-md-4 offset-2 col-8 form-group">
        <div class="detail-content row ml-0 mr-0 ">
          <img class="pl-xl-5 pl-lg-3 img-detail " src="../../assets/detail-image-2.png">
          <div class="text-right ml-4">
            <span>ไม่บาดเจ็บ</span>
            <br>
            <template v-if="countPatient[0].no_injury_patient_total">
              <span>{{ countPatient[0].no_injury_patient_total }} ราย</span>
            </template>
            <template v-else>
              <span>0 ราย</span>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3 content ">
      <b-nav link style="font-size: 22px" tabs>
        <b-nav-item :class="{active: show_table === 1}" @click="show_table = 1">
          รายเหตุการณ์
        </b-nav-item>
        &nbsp
        <b-nav-item :class="{active: show_table === 2}" @click="show_table = 2">
          รายบุคคล
        </b-nav-item>
        &nbsp
      </b-nav>

      <nav class="mt-3 navbar navbar-expand-lg navbar-light">
        <div class="ml-auto">
          <form class="form-inline my-2 my-lg-0">
            <template v-if="show_table == 1">
              <input v-model="search.name"
                     class="form-group form-control ml-2 mr-sm-1"
                     placeholder="ชื่อ-นามสกุล/เลขประจำตัวประชาชน"
                     type="text"/>
              <multiselect
                v-model="search.province"
                :options="optionProvince"
                class="form-control select"
                deselect-label=""
                label="name"
                placeholder="เลือกจังหวัด"
                select-label=""
                selectedLabel=""
                track-by="name">
              </multiselect>
              <date-picker ref="datePicker"
                           v-model="search.start_date"
                           :format="changeFormat"
                           :lang="lang"
                           :not-after="this.currentDate"
                           placeholder="วันที่เกิดเหตุ (เริ่มต้น)"
                           @focus="initDate(search.start_date)"
                           @calendar-change="convertYear"
              >
              </date-picker>
              &nbsp;
              <date-picker ref="datePicker"
                           v-model="search.end_date"
                           :calendar-year="this.calendarYear"
                           :format="changeFormat"
                           :lang="lang"
                           :not-after="this.currentDate"
                           :not-before="search.start_date"
                           placeholder="วันที่เกิดเหตุ (สิ้นสุด)"
                           @focus="initDate(search.end_date)" @calendar-change="convertYear">
              </date-picker>
              &nbsp;

              <b-button class=" btn btn-success my-2 my-sm-0 pb-0"
                        type="button" variant="dark"
                        @click="getEvent">
                <i class="fas fa-search"></i> ค้นหา
              </b-button>
              &nbsp;
              <b-button class="btn btn-success my-2 my-sm-0 pb-0" variant="dark">
                <download-excel
                  :fetch="fetchDataEvent"
                  :fields="json_fields_event"
                  :meta="json_meta"
                  name="event_data.xls"
                  style="background-color: #006738;font-size: 20px;font-weight: 700"
                  worksheet="Event Data">
                  <i class="far fa-file-alt"></i> Excel
                </download-excel>
              </b-button>
            </template>
            <template v-else>

              <input v-model="search_patient.name"
                     class="form-group form-control ml-3 mr-sm-2 "
                     placeholder="ชื่อ-นามสกุล/เลขประจำตัวประชาชน"
                     type="text"/>
              <multiselect
                v-model="search_patient.province"
                :options="optionProvince"
                class="form-control select"
                deselect-label=""
                label="name"
                placeholder="เลือกจังหวัด"
                select-label=""
                selectedLabel=""
                track-by="name">
              </multiselect>

              <input v-model="search_patient.event_id"
                     class="form-group form-control ml-3 mr-sm-2 "
                     placeholder="รหัสเหตุการณ์"
                     type="text"/>

<!--              <multiselect-->
<!--                v-model="search_patient.event_id"-->
<!--                :options="optionEvent"-->
<!--                class="form-control select"-->
<!--                deselect-label=""-->
<!--                label="id"-->
<!--                placeholder="เลือกเหตุการณ์"-->
<!--                select-label=""-->
<!--                selectedLabel=""-->
<!--                track-by="id">-->
<!--              </multiselect>-->


              <div class="input-group " style="width: 110px">
                <multiselect
                  v-model="search_patient.gender"
                  :options="optionGender"
                  class="form-control select"
                  deselect-label=""
                  label="name"
                  placeholder="เพศ"
                  select-label=""
                  selectedLabel=""
                  track-by="name">
                </multiselect>
              </div>
              &nbsp;
              <b-button class="btn btn-success my-2 my-sm-0 pb-0"
                        type="button" variant="dark"
                        @click="getPatient">
                <i class="fas fa-search"></i> ค้นหา
              </b-button>
              &nbsp;
              <b-button class="btn btn-success my-2 my-sm-0 pb-0" variant="dark">
                <download-excel
                  :fetch="fetchDataPatient"
                  :fields="json_fields_patient"
                  :meta="json_meta"
                  name="patient_data.xls"
                  style="background-color: #006738;font-size: 20px;font-weight: 700">
                  <i class="far fa-file-alt"></i> Excel
                </download-excel>
              </b-button>


            </template>

          </form>
        </div>
      </nav>
    </div>


    <div class="mt-2 table-responsive font-size">
      <template v-if="show_table == 1">
        <table class="table table-borderless text-center">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <th @click="sortDataEven('id')">เหตุการณ์ที่
              <i v-if="sort.field != 'id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('report_date')">วันที่เกิดเหตุ
              <i v-if="sort.field != 'report_date'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'report_date' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'report_date' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('location_province_id')">จังหวัดที่เกิดเหตุ
              <i v-if="sort.field != 'location_province_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'location_province_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'location_province_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('location_district_id')">อำเภอ
              <i v-if="sort.field != 'location_district_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'location_district_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'location_district_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('location_sub_district_id')">ตำบล
              <i v-if="sort.field != 'location_sub_district_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'location_sub_district_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'location_sub_district_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('death_patient')">เสียชีวิต (ราย)
              <i v-if="sort.field != 'death_patient'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'death_patient' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'death_patient' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('injury_patient')">บาดเจ็บ (ราย)
              <i v-if="sort.field != 'injury_patient'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'injury_patient' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'injury_patient' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataEven('no_injury_patient')">ไม่บาดเจ็บ (ราย)
              <i v-if="sort.field != 'no_injury_patient'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'no_injury_patient' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'no_injury_patient' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>

          </tr>
          </thead>
          <tbody>
          <template v-for="(data,index) in eventList">
            <tr>
              <td>
                <a @click="goToEventForm(data.id)" style="cursor: pointer">
                  <i class="far fa-edit" style="color: #006738"></i>
                </a>
              </td>
              <td>
                <a @click="printEventPDF(data.id)" style="cursor: pointer">
                  <i class="fas fa-print " style="color: #006738"></i>
                </a>
              </td>
              <td>
                {{ data.id }}
              </td>
              <td>
                <!--                {{ convertDate(data.report_date) }}-->
                {{ convertDate(data.report_date) }}
              </td>
              <td>
                {{ data.location_province.name }}
              </td>
              <td>
                {{ data.location_district.name }}
              </td>
              <td>
                {{ data.location_sub_district ? data.location_sub_district.name : '-' }}
              </td>
              <td>
                {{ data.death_patient }}
              </td>
              <td>
                {{ data.injury_patient }}
              </td>
              <td>
                {{ data.no_injury_patient }}
              </td>
            </tr>
          </template>

          </tbody>
        </table>
      </template>

      <template v-else>
        <table class="table table-borderless text-center">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <th @click="sortDataPatient('event_id')">เหตุการณ์ที่
              <i v-if="sort.field != 'event_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'event_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'event_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataPatient('order')">รายที่
              <i v-if="sort.field != 'order'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'order' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'order' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataPatient('first_name')">ชื่อ
              <i v-if="sort.field != 'first_name'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'first_name' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'first_name' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataPatient('gender_id')">เพศ
              <i v-if="sort.field != 'gender_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'gender_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'gender_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataPatient('age')">อายุ (ปี)
              <i v-if="sort.field != 'age'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'age' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'age' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
            <th @click="sortDataPatient('location_province_id')">จังหวัดที่เกิดเหตุ
              <i v-if="sort.field != 'location_province_id'" class="fas fa-sort" style="color: #006738"></i>
              <i v-if="sort.field == 'location_province_id' && sort.sorttype === 'desc'" class="fas fa-sort-up"
                 style="color: #006738"></i>
              <i v-if="sort.field == 'location_province_id' && sort.sorttype === 'asc'" class="fas fa-sort-down"
                 style="color: #006738"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(data,index) in patientList">
            <tr>
              <td>
                <a @click="goToPatientForm(data.event_id,data.order)" style="cursor: pointer">
                  <i class="far fa-edit" style="color: #006738"></i>
                </a>
              </td>
              <td>
                <a @click="printPatientPDF(data.id)" style="cursor: pointer">
                  <i class="fas fa-print" style="color: #006738"></i>
                </a>
              </td>
              <td>
                {{ data.event_id }}
              </td>
              <td>
                {{ data.order }}
              </td>
              <td>
                <template v-if="data.first_name == '' && data.last_name == ''">
                  ไม่ทราบชื่อ ไม่ทราบนามสกุล
                </template>
                <template v-else-if="data.first_name && data.last_name == ''">
                  {{ data.first_name }} ไม่ทราบนามสกุล
                </template>
                <template v-else-if="data.first_name == '' && data.last_name">
                  ไม่ทราบชื่อ {{ data.last_name }}
                </template>
                <template v-else>
                  {{ data.first_name }} {{ data.last_name }}
                </template>

              </td>
              <td>
                <template v-if="data.gender_id== 1">
                  ชาย
                </template>
                <template v-else-if="data.gender_id==2">
                  หญิง
                </template>
                <template v-else>
                  ไม่ทราบเพศ
                </template>
              </td>
              <td>
                <template v-if="!data.age && !data.age_month">
                  ไม่ระบุ
                </template>
                <template v-else>
                  {{ data.age }}
                </template>
              </td>
              <td>
                <template v-if="data.evenet_province_name">
                  {{ data.evenet_province_name }}
                </template>
                <template v-else>
                  ไม่ระบุ
                </template>
              </td>
            </tr>
          </template>

          </tbody>
        </table>
      </template>
    </div>

    <template v-if="show_table == 1">
      <div v-if="eventList.length > 0">
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getEvent">
        </vue-pagination>
      </div>
    </template>

    <template v-else-if="show_table == 2">
      <div v-if="patientList && patientList.length > 0">
        <vue-pagination :pagination="dataPaginatePatient"
                        @paginate="getPatient">
        </vue-pagination>
      </div>
    </template>

    <!--      <pre class="alert-danger">{{eventList}}</pre>-->
    <Loading v-if="isLoading"></Loading>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker/lib/datepicker.js'
import VuePagination from '../../components/Pagination'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
import { domain } from '../../util/Constants'
import axios from 'axios'
import Loading from "@/components/Loading.vue";

export default {
  name: 'Status',
  components: {
    Loading,
    DatePicker,
    VuePagination,
    Multiselect,
    JsonExcel,
  },
  created () {
    if(this.user_login !== 1 && this.user_login !== null){
      this.sort.area_id = this.user_login.user.area_id
      this.sort.user_type_id = this.user_login.user.user_type_id
      this.sort.province_id = this.user_login.user.province_id
      this.sort.district_id = this.user_login.user.district_id
      this.sort.hospital_code = this.user_login.user.hospital_code
    }else{
      this.$router.push({path: '/login'})
    }
    Promise.all([
      this.$store.dispatch('Event/clearSearch'),
      this.$store.dispatch('Patient/clearSearch'),
      this.$store.dispatch('Event/setEvent', this.sort),
      this.$store.dispatch('Common/setProvince', this.user_login.user.id),
      this.$store.dispatch('Patient/setPatient', this.sort),
      this.$store.dispatch('Event/getPatientAll'),
      this.$store.dispatch('Event/setEventAll')
    ]).finally(() => {
      this.isLoading = false;
    })
    // this.$store.dispatch('Event/clearSearch')
    // this.$store.dispatch('Patient/clearSearch')
    // this.$store.dispatch('Event/setEvent', this.sort)
    // this.$store.dispatch('Common/setProvince', this.user_login.user.id)
    // this.$store.dispatch('Patient/setPatient', this.sort)
    // this.$store.dispatch('Event/getPatientAll')
    // this.$store.dispatch('Event/setEventAll')
    this.getCurrentDate()
  },
  computed: {
    ...mapState({
      eventList: state => {
        return state.Event.event
      },
      patientList: state => {
        return state.Patient.patient
      },
      dataPaginate: state => {
        return state.Event.dataPaginate
      },
      dataPaginatePatient: state => {
        return state.Patient.dataPaginate
      },
      countPatient: state => {
        return state.Event.patient_all
      },
      optionProvince: state => {
        return state.Common.provinces
      },
      optionEvent: state => {
        return state.Event.optionEvent
      },
      search: state => {
        return state.Event.search
      },
      search_patient: state => {
        return state.Patient.search
      },
      user_login: state => {
        return state.Auth.user_login
      },
      event_form: state => {
        return state.Event.form
      },
    })
  },
  data () {
    const calendarYear = null
    return {
      sort: {
        page: 1,
        field: '',
        sorttype: '',
        area_id: '',
        province_id: '',
        district_id: '',
        user_type_id: '',
        hospital_code: '',
        event_id: '',
        gender: '',
        name: '',
      },
      changeFormat: {
        stringify: (date) => {
          return date ? moment(date).add(543, 'y').format('DD-MM-YYYY') : null
        },
        parse: (value) => {
          return value ? moment(value, 'DD-MM-YYYY').subtract(543, 'y').toDate() : null
        }
      },
      lang: {
        days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
        months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
        placeholder: {
          date: 'วว/ดด/ปปปป',
        },
      },
      event_submit: false,
      province_id: '',
      show_table: 1,
      currentDate: '',
      json_fields_patient: {
        'ID เหตุการณ์': 'event_id',
        'วันที่เกิดเหตุการณ์': 'event_day',
        'เดือนที่เกิดเหตุ': 'event_month',
        'ปีที่เกิดเหตุ': 'event_year',
        'เวลาที่เกิดเหตุ': 'event_time',
        'สถานที่เกิดเหตุ': 'event_location',
        'หมู่ที่เกิดเหตุ': 'event_village_no',
        'ตำบลที่เกิดเหตุ': 'evenet_sub_district_name',
        'อำเภอที่เกิดเหตุ': 'evenet_district_name',
        'จังหวัดที่เกิดเหตุ': 'evenet_province_name',
        'ละติจูดของที่เกิดเหตุ': 'event_lat',
        'ลองจิจูดของที่เกิดเหตุ': 'event_lng',
        'ลักษณะการเกิดเหตุ': 'event_type_event',
        'ประเภทของแหล่งน้ำ': 'event_type_water',
        'รายที่': 'order',
        'คำนำหน้าชื่อ': 'title',
        'ชื่อ': 'first_name',
        'นามสกุล': 'last_name',
        'เลขประจำตัวประชาชน/เลขหนังสือเดินทาง': {
          callback: (value) => {
            return `${value.id_number} \n`
          }
        },
        'สัญชาติ': 'nationality_name',
        'ที่อยู่': 'address_no',
        'หมู่': 'village_no',
        'ตำบล': 'location_sub_district.name',
        'อำเภอ': 'location_district.name',
        'จังหวัด': 'location_province.name',
        'เพศ': 'gender_name',
        'อายุ (ปี)': 'age',
        'อายุ (เดือน)': 'age_month',
        'การว่ายน้ำ': 'swimming_name',
        'ทักษะการเอาชีวิตรอด': 'swimming_ability_name',
        'ขณะเกิดเหตุ (ณ จุดเกิดเหตุ) คนที่จมน้ำอยู่กับใคร': 'people_with_patient_name',
        'โดยขณะนั้นผู้ปกครองทำกิจกรรมดังนี้': 'activity_people_with_patient_name',
        'กิจกรรมก่อนเกิดเหตุ': 'activity_before_event_name',
        'ผู้ดูแลก่อนเกิดเหตุ': 'caregiver_name',
        'ระยะทางโดยประมาณระหว่างบ้านถึงที่เกิดเหตุ\n(เมตร)': 'distance',
        'เกิดเหตุภายในบ้าน': 'has_event_at_home',
        'การใช้อุปกรณ์ช่วยลอยน้ำขณะเกิดเหตุ': 'has_floating_device',
        'อุปกรณ์': 'has_floating_device_name',
        'การสวมเสื้อชูชีพ/เสื้อพยุงตัว ขณะเกิดเหตุ': 'has_life_jacket',
        'ปัจจัยเสี่ยง/พฤติกรรมเสี่ยงต่อการเกิดเหตุ': 'risk_factors_name',
        'สถานะ': 'alive_status',
        // 'สถานะผู้ป่วยที่รับไว้รักษา': 'injure_patient_status_name.injure_patient_status',
        'สถานะหลังเกิดเหตุจมน้ำ': 'status_after',
        'วันที่เริ่มมีอาการ': 'date_illness',
        'วันที่รักษาวันแรก': 'date_treat',
        'วันที่เสียชีวิต': 'day_death',
        'เดือนที่เสียชีวิต': 'month_death',
        'ปีที่เสียชีวิต': 'year_death',
        'คนจมน้ำได้รับการช่วยเหลือขึ้นมาจากน้ำโดยใคร': 'rescuer_name',
        'ผู้ช่วยเหลือช่วยขึ้นมาจากน้ำด้วยวิธีใด': 'type_help_name',
        'ระยะเวลาตั้งแต่มีคนจมน้ำจนกระทั่งมีผู้มาช่วยเหลือใช้ระยะเวลา (นาที)': 'time',
        'ได้รับการปฐมพยาบาลหรือไม่': 'first_aid',
        'เหตุผลที่ไม่ปฐมพยาบาล/ผู้ปฐมพยาบาล': 'type_people_first_aid_name',
        'วิธีปฐมพยาบาล': 'type_first_aid',
        'นำส่งสถานบริการสาธารณสุขหรือไม่': 'has_deliver',
        'ผู้นำส่งสถานบริการสาธารณสุข': 'deliver_name',
      },
      json_fields_event: {
        'ID เหตุการณ์': 'id',
        'ผู้รายงาน': {
          callback: (value) => {
            return `${value.title || ''} ${value.name || ''}`.trim()
          }
        },
        'ตำแหน่ง': 'role',
        'ประเภทหน่วยงาน': 'department.name',
        'ชื่อหน่วยงาน': 'department_name',
        'จังหวัด': 'province_department.name',
        'เบอร์โทรศัพท์': {
          callback: (value) => {
            return `${value.phone_number_department} \n`
          }
        },
        'โทรสาร': {
          callback: (value) => {
            return `${value.fax_number_department} \n`
          }
        },
        'วันที่รายงาน': 'date_report',
        'สถานที่เกิดเหตุ': 'location',
        'หมู่': 'village_no',
        'ตำบล': 'location_sub_district.name',
        'อำเภอ': 'location_district.name',
        'จังหวัดที่เกิดเหตุ': 'location_province.name',
        'ละติจูด': 'lat',
        'ลองจิจูด': 'lng',
        'ลักษณะการเกิดเหตุ': 'type_event',
        'วันที่เกิดเหตุ': 'day',
        'เดือนที่เกิดเหตุ': 'month',
        'ปีที่เกิดเหตุ': 'year',
        'เวลาที่เกิดเหตุ': {
          callback: (value) => {
            return `${value.event_time} \n`
          }
        },
        'จำนวนคนที่เกิดเหตุในเหตุการณ์เดียวกัน': 'total_patient',
        'จำนวนผู้เสียชีวิต': 'death_patient',
        'จำนวนผู้บาดเจ็บ': 'injury_patient',
        'จำนวนผู้ไม่บาดเจ็บ': 'no_injury_patient',
        'สาเหตุของเหตุการณ์': 'cause_of_event',
        'กิจกรรมที่ทำขณะเกิดเหตุ': 'activity_during_event',
        'การดำเนินการหลังเกิดเหตุ': 'proceed_after_event',
        'ประเภทของแหล่งน้ำ': 'water_type',
        'ระดับความลึก (เซนติเมตร)': 'depth_centimeter',
        'การจัดการแหล่งน้ำเสี่ยง ก่อนเกิดเหตุ': 'has_management_risk_before_name',
        'การจัดการแหล่งน้ำเสี่ยง หลังเกิดเหตุ': 'has_management_risk_after_name',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      optionGender: [
        {
          'id': '1',
          'name': 'ชาย'
        },
        {
          'id': '2',
          'name': 'หญิง'
        }
      ],
      isLoading:true,
    }
  },
  methods: {
    convertDate (date, format = 'DD/MM/YYYY') {
      return moment(date).add('years', 543).format(format)
    },
    initDate (date) {
      const d = new Date(date)
      if (Object.prototype.toString.call(d) === '[object Date]') {
        // it is a date
        if (isNaN(d.getTime())) {  // d.valueOf() could also work
          // date is not valid
          date = new Date()
        } else {
          // date is valid
          date = new Date(date)
        }
      } else {
        // not a date
        date = new Date()
      }
      this.convertYear(date)
    },
    convertYear (date, oldDate, type) {
      const calendarYear = date.getFullYear()
      for (const item of document.getElementsByClassName('mx-current-year')) {
        item.href = '#'
        const innerHTML = item.innerHTML
        const innerHTMLsplit = innerHTML.split(' ~ ')
        if (innerHTMLsplit.length === 2) {
          item.innerHTML = `${(calendarYear - 9) + 543} ~ ${calendarYear + 543}`
        } else {
          item.innerHTML = `${calendarYear + 543}`
        }
      }
    },
    async fetchDataEvent () {
      this.isLoading = true;
      const page = this.dataPaginatePatient.current_page
      let startDate = this.search.start_date ? moment(this.search.start_date).format('YYYY-MM-DD') : ''
      let endDate = this.search.end_date ? moment(this.search.end_date).format('YYYY-MM-DD') : ''
      let province_id
      if (this.user_login.user.user_type_id === 0 || this.user_login.user.user_type_id == 1) {
        province_id = this.search.province ? this.search.province.code : ''
      } else {
        province_id = this.user_login.user.province_id
      }

      var url = domain + '/event?page=' + page +
        '&field=' + this.sort.field +
        '&sorttype=' + this.sort.sorttype +
        '&area_id=' + this.user_login.user.area_id +
        '&user_type_id=' + this.user_login.user.user_type_id +
        '&district_id=' + this.user_login.user.district_id +
        '&province_id=' + province_id +
        '&start_date=' + startDate +
        '&end_date=' + endDate +
        '&name=' + this.search.name +
        '&excel=1'

      const authData = JSON.parse(localStorage.getItem('vuex'));
      const token = authData.Auth.accessToken||null;
      const response = await axios.get(url,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      this.isLoading = false;
      return response.data;

    },
    async fetchDataPatient () {
      const page = this.dataPaginatePatient.current_page
      let data = {
        page: page,
        event_id: '',
        province_id: '',
        district_id: '',
        area_id: '',
        name: this.search_patient.name ? this.search_patient.name : '',
        gender: this.search_patient.gender ? this.search_patient.gender.id : '',
        field: this.sort.field,
        sorttype: this.sort.sorttype,
        user_type_id: this.user_login.user.user_type_id
      }

      if (this.search_patient.province) {
        data.province_id = this.search_patient.province.code
      }
      if (this.search_patient.event_id) {
        data.event_id = this.search_patient.event_id
      }
      if (this.user_login.user.user_type_id === 0 || this.user_login.user.user_type_id == 1) {
        if (this.search.province) {
          data.province_id = this.search.province.code
        } else if (this.search_patient.province) {
          data.province_id = this.search_patient.province.code
        }
        if (this.user_login.user.user_type_id === 1) {
          data.area_id = this.user_login.user.area_id
          data.district_id = this.user_login.user.district_id
        }
      } else {
        data.area_id = this.user_login.user.area_id,
        data.province_id = this.user_login.user.province_id
        data.district_id = this.user_login.user.district_id
      }

      // let province_id = this.search_patient.province ? this.search_patient.province.id : ""
      // let name = this.search_patient.name ? this.search_patient.name : ""
      // let gender = this.search_patient.gender ? this.search_patient.gender.id : ""
      // let event_id = this.search_patient.event_id ? this.search_patient.event_id : ""
      var url = domain + '/patient?page=' + data.page +
        '&field=' + data.field +
        '&sorttype=' + data.sorttype +
        '&area_id=' + data.area_id +
        '&user_type_id=' + data.user_type_id +
        '&province_id=' + data.province_id +
        '&district_id=' + data.district_id +
        '&event_id=' + data.event_id +
        '&name=' + data.name +
        '&gender=' + data.gender +
        '&excel=1'
      // window.open(url, '_blank')
      const response = await axios.get(url)
      return response.data
    },
    sortDataEven (field) {
      var sorttype = this.sort.sorttype
      if (sorttype === '') {
        sorttype = 'asc'
      } else if (sorttype === 'asc') {
        sorttype = 'desc'
      } else if (sorttype === 'desc') {
        sorttype = 'asc'
      }

      this.sort.field = field
      this.sort.sorttype = sorttype

      this.getEvent()
    },
    sortDataPatient (field) {
      var sorttype = this.sort.sorttype
      if (sorttype === '') {
        sorttype = 'asc'
      } else if (sorttype === 'asc') {
        sorttype = 'desc'
      } else if (sorttype === 'desc') {
        sorttype = 'asc'
      }

      this.sort.field = field
      this.sort.sorttype = sorttype

      this.getPatient()
    },
    getCurrentDate () {
      const now = new Date()
      this.calendarYear = now.getFullYear() + 543
      this.currentDate = moment().format('YYYY-MM-DD')
    },
    goToEventForm (id) {
      this.showEventForm(id)
      this.loadScrean()
      this.openEvenForm(id)
    },
    loadScrean () {
      let timerInterval
      this.$swal.fire({
        title: 'กำลังประมวลผล โปรดรอ',
        timer: 3000,
        showCancelButton: false,
        showConfirmButton: false
      })
    },
    openEvenForm (id, call = 0) {

      if (this.event_form.id == id) {
        // this.$router.push({
        //   name: "EventForm",
        //   params: {id}
        // });

        let path = this.$router.resolve({
          name: 'EventForm',
          query: { id: id }
        })
        window.open(path.href, '_self')
      } else {
        if (call < 10) {
          call = call + 1
          var self = this
          setTimeout(function () {
            self.openEvenForm(id, call)
          }, 1000)
        }
      }
    },
    goToPatientForm (event_id, order) {
      this.showPatientForm(event_id, order)
      this.$router.push({
        name: 'DrowningForm'
      })
    },
    showEventForm (id) {
      this.$store.dispatch('Event/showEvent', id)
    },
    showPatientForm (event_id, order) {
      this.$store.dispatch('Event/showEvent', event_id)
      this.$store.dispatch('Patient/showPatient', {
        event_id: event_id,
        order: order
      })
    },
    getEvent () {
      const page = this.dataPaginate.current_page

      if (this.search.start_date && !this.search.end_date) {
        alert('กรุณาเลือกวันที่เกิดเหตุการณ์ (สิ้นสุด)')
      } else if (!this.search.start_date && this.search.end_date) {
        alert('กรุณาเลือกวันที่เกิดเหตุการณ์ (เริ่มต้น)')
      } else {
        this.event_submit = true
        //change date format
        if (this.search.start_date && this.search.end_date) {
          this.search.start_date = moment(this.search.start_date).format('YYYY-MM-DD')
          this.search.end_date = moment(this.search.end_date).format('YYYY-MM-DD')
        } else {
          this.search.start_date = ''
          this.search.end_date = ''
        }

      }

      let data = {
        page: page,
        province_id: this.search.province ? this.search.province.code : '',
        start_date: this.search.start_date,
        end_date: this.search.end_date,
        name: this.search.name ? this.search.name : '',
        field: this.sort.field,
        sorttype: this.sort.sorttype,
        area_id: this.user_login.user.area_id,
        user_type_id: this.user_login.user.user_type_id,
        hospital_code: this.user_login.user.hospital_code,
        district_id: this.user_login.user.district_id,
      }
      // console.log(this.user_login.user)
      //paginate search
      if (this.user_login.user.user_type_id === 0 || this.user_login.user.user_type_id === 1) {
        this.$store.dispatch('Event/setEvent', data)
      }
      //paginate get data
      else {
        data.province_id = this.user_login.user.province_id,

          this.$store.dispatch('Event/setEvent', data)
      }

      this.getPatient()
    },
    printEventPDF (id) {
      const token = this.$store.state.Auth.accessToken
      window.open(domain + '/event_pdf/' + id + (token ? '?token=' + encodeURIComponent(token) : ''), '_blank')
    },
    printPatientPDF (id) {
      window.open(domain + '/patient_pdf/' + id, '_blank')
    },
    getPatient () {
      this.isLoading = true;
      const page = this.dataPaginatePatient.current_page

      if (this.search.date) {
        this.search.date = moment(this.search.date).format('YYYY-MM-DD')
      } else {
        this.search.date = ''
      }

      this.event_submit = true

      let data = {
        page: page,
        event_id: '',
        province_id: '',
        district_id: '',
        area_id: '',
        name: this.search_patient.name ? this.search_patient.name : '',
        gender: this.search_patient.gender ? this.search_patient.gender.id : '',
        field: this.sort.field,
        sorttype: this.sort.sorttype,
        user_type_id: this.user_login.user.user_type_id
      }

      if (this.search_patient.province) {
        data.province_id = this.search_patient.province.code
      }
      if (this.search_patient.event_id) {
        data.event_id = this.search_patient.event_id
      }
      if (this.user_login.user.user_type_id === 0 || this.user_login.user.user_type_id === 1) {
        if (this.search.province) {
          data.province_id = this.search.province.code
        } else if (this.search_patient.province) {
          data.province_id = this.search_patient.province.code
        }
        if (this.user_login.user.user_type_id === 1) {
          data.area_id = this.user_login.user.area_id
          data.district_id = this.user_login.user.district_id
        }
      } else {
        data.area_id = this.user_login.user.area_id,
          data.province_id = this.user_login.user.province_id
        data.district_id = this.user_login.user.district_id
      }

      this.$store.dispatch('Patient/setPatient', data).then(()=>{
        this.isLoading = false;
      })
    },
  }
}
</script>

<style scoped>

hr {
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.select {
  border: 0px;
  font-size: 20px;
  font-weight: 700;
}

/*.multiselect__input input {*/
/*    font-size: 18px !important;*/
/*}*/

/*.multiselect,*/
/*.multiselect__single input {*/
/*    font-size: 18px !important;*/
/*}*/

.content {
  text-align: center;
}

.detail-content {
  border: 3px solid #006738;
  border-radius: 15px;
  padding: 10px;
  font-size: 35px;
  color: #006738;
  text-align: center;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #006738;
  background-color: #006738;
}

.custom-control-label::before {
  background-color: #FCFCFC;
  border: #006738 solid 2px;
}

table tr th {
  border-top: 3px solid #006738;
  border-bottom: 3px solid #006738;
}

.font-size {
  font-size: 22px;
  line-height: 22px;
}

input[type="text"] {
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 700;
}

select {
  font-size: 20px;
  font-weight: 700;
}

button[type="button"] {
  border-color: #006738;
  background-color: #006738;
  font-weight: 700;
  font-size: 20px;
}

.img-detail {
  height: 100px;
}

.nav-item.active .nav-link {
  color: white;
  background-color: #006738;
  border-color: #006738;
}

.nav-item .nav-link {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  border-left: 2px solid rgba(0, 0, 0, 0.1);
}

.nav-tabs {
  border-bottom: 2px solid #dee2e6;
}

a {
  color: #006738;
  text-decoration: none;
  background-color: transparent;
}

@media only screen and (max-width: 991px) {
  .img-detail {
    height: 70px;
  }

  .detail-content {

    padding: 10px;
    font-size: 25px;
  }
}

@media only screen and (max-width: 767px) {
  .img-detail {
    height: 100px;
  }

  .detail-content {

    padding: 10px;
    font-size: 32px;
  }
}

@media only screen and (max-width: 500px) {
  .img-detail {
    height: 55px;
  }

  .detail-content {

    padding: 10px;
    font-size: 20px;
  }
}


</style>
